export default __webpack_public_path__ + "static/citadel-7da3fa76430784da7e17935f3ad8a1d5.webp";